<section>
  <ng-content select="input"></ng-content>
</section>
